import { B2C_ONBOARDING_PAGES } from "core/consts";
import { B2COnboardingPage } from "core/types";
import {
  B2C_PRIMARY_COLOR,
  STEPPER_INACTIVE,
} from "ds_legacy/materials/colors";
import { HorizontalLayout } from "ds_legacy/materials/layouts";
import {
  border,
  margin,
  padding,
  responsiveCSS,
  sizing,
} from "ds_legacy/materials/metrics";
import { Fragment } from "react";
import styled, { css } from "styled-components";
import { PAGE_MAX_WIDTH } from "./common";

export const STEPS: B2COnboardingPage[][] = [
  [B2C_ONBOARDING_PAGES.TARGET],
  [B2C_ONBOARDING_PAGES.START_DATE],
  [B2C_ONBOARDING_PAGES.CARE_TYPE],
  [B2C_ONBOARDING_PAGES.CARE_SOLUTION, B2C_ONBOARDING_PAGES.CARE_TERM],
  [B2C_ONBOARDING_PAGES.LOCATION],
];
const getActiveIndex = (activePage: B2COnboardingPage) =>
  STEPS.findIndex((step) => step.includes(activePage));
const isStepActive = (activePage: B2COnboardingPage, currentIndex: number) =>
  currentIndex <= getActiveIndex(activePage);

export default function Stepper({
  activePage,
}: {
  activePage: B2COnboardingPage;
}) {
  const showStepper = STEPS.some((step) =>
    step.find((page) => page === activePage),
  );
  if (!showStepper) return null;
  return (
    <StepperWrapper>
      {STEPS.map((_, index) => (
        <Fragment key={index}>
          <Circle isActive={isStepActive(activePage, index)} />
          {index < STEPS.length - 1 && (
            <Line isActive={isStepActive(activePage, index + 1)} />
          )}
        </Fragment>
      ))}
    </StepperWrapper>
  );
}

const StepperWrapper = styled(HorizontalLayout)`
  max-width: ${PAGE_MAX_WIDTH};
  position: relative;
  width: 100%;
  height: ${sizing(1.5)};
  margin: ${margin(0, 3)};
  padding: ${padding(5.5, 0)};
  align-items: center;
  justify-content: center;
  ${responsiveCSS({
    desktop: [`padding: ${padding(5, 0)}`, `justify-content: flex-start`],
    mobile: [
      `padding: ${padding(3, 0)}`,
      `justify-content: center`,
      `max-width: ${sizing(37.5)}`,
    ],
    tablet: [`padding: ${padding(5, 0)}`, `justify-content: center`],
  })};
`;
const Circle = styled.div<{ isActive?: boolean }>`
  width: ${sizing(1.5)};
  height: ${sizing(1.5)};
  border-radius: 50%;
  flex-shrink: 0;
  flex-grow: 0;
  ${({ isActive }) =>
    isActive
      ? css`
          background: ${B2C_PRIMARY_COLOR};
          border: ${border({ color: B2C_PRIMARY_COLOR })};
        `
      : css`
          background: transparent;
          border: ${border({ color: STEPPER_INACTIVE })};
          opacity: 0.2;
        `};
`;
const Line = styled.div<{ isActive?: boolean }>`
  width: ${sizing(9)};
  height: ${sizing(0.25)};
  ${({ isActive }) =>
    isActive
      ? css`
          background: ${B2C_PRIMARY_COLOR};
        `
      : css`
          background: ${STEPPER_INACTIVE};
          opacity: 0.2;
        `};
`;
